import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyDokHqFC43vJo0Tl7ERcrzvcEIF5dHfOwM",
  authDomain: "julia-moore-website.firebaseapp.com",
  databaseURL: "https://julia-moore-website.firebaseio.com",
  projectId: "julia-moore-website",
  storageBucket: "julia-moore-website.firebasestorage.app",
  messagingSenderId: "307309907964",
  appId: "1:307309907964:web:5e1b048a536c456e456c79",
};

export default initializeApp(firebaseConfig);
